import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-errors5xx-popup',
  templateUrl: './errors5xx-popup.component.html',
  styleUrls: ['./errors5xx-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Err5XXPopupComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: string) {}

  ngOnInit(): void {}
}
